// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSupplier_navbar__ogtHe","logo":"NavbarSupplier_logo__Hovft","navLinks":"NavbarSupplier_navLinks__auG36","navItem":"NavbarSupplier_navItem__K7YVE"};